import { useQuery } from "@tanstack/react-query";

import type { CartonPropertyGroup } from "@/schemas/carton-property-group";
import { getCartonPropertyGroups } from "@/api/carton-property-group-api";

export const CARTON_PROPERTY_GROUPS_QUERY_KEY = "carton-property-groups";

export const useCartonPropertyGroups = () => {
	return useQuery<CartonPropertyGroup[]>({
		queryKey: [CARTON_PROPERTY_GROUPS_QUERY_KEY],
		queryFn: () => getCartonPropertyGroups(),
		initialData: [],
		retry: false,
	});
};
